<template>
  <b-row>
    <b-col cols="12">
      <small class="text-muted">
        You can upload csv/xls file manually or fetch from email using Order No.
      </small>
    </b-col>
    <b-col cols="6">
      <b-form-group
        label="Order No"
        label-for="order-no"
      >
        <b-input-group>
          <b-form-input
            id="order-no"
            v-model="orderNo"
            placeholder="Enter Order No"
          />
          <b-input-group-append>
            <b-button
              variant="primary"
              :disabled="fetching"
              @click="fetchFromEmail"
            >
              Fetch
              <b-spinner
                v-if="fetching"
                small
              />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>

    <b-col cols="6">
      <b-form-group
        label="CSV/XLS File"
        label-for="csv-file"
      >

        <!-- Manual Upload -->
        <b-form-file
          v-if="!fetchedFile"
          id="csv-file"
          v-model="csvFile"
          accept=".csv,.xls"
        />

        <!-- Fetched File Preview -->
        <div
          v-else
          class="d-flex align-items-center justify-content-between flex-column"
        >
          <div>
            <small>{{ fetchedFile.file_name }}</small>
          </div>

          <div>
            <b-button
              size="sm"
              variant="outline-primary"
              :href="fetchedFile.file_url"
              target="_blank"
            >
              View
            </b-button>

            <b-button
              size="sm"
              variant="outline-danger"
              class="ml-1"
              @click="removeFetchedFile"
            >
              Remove
            </b-button>
          </div>
        </div>

      </b-form-group>
    </b-col>

  </b-row>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BButton, BFormInput, BFormFile, BSpinner,
  BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'

import axios from 'axios'

export default {
  components: {
    BRow,
    BCol,
    BFormFile,
    BFormGroup,
    BFormInput,
    BButton,
    BSpinner,
    BInputGroup,
    BInputGroupAppend,
  },

  data() {
    return {
      csvFile: null,
      orderNo: null,
      fetching: false,
      fetchedFile: null, // { file_id, file_name, preview_url }
      errorMessage: null,
    }
  },
  watch: {
    // Emit upward whenever the effective file selection changes
    csvFile(val) {
      this.$emit('change', { csvFile: val, fetchedFile: null })
    },
    fetchedFile(val) {
      this.$emit('change', { csvFile: null, fetchedFile: val })
    },
    errorMessage(val) {
      this.$emit('error', val)
    },
  },
  methods: {
    async fetchFromEmail() {
      if (!this.orderNo) {
        this.errorMessage = 'Order No is required'
        return
      }

      this.errorMessage = null
      this.fetching = true

      try {
        const res = await axios.post('/search_xls_from_po_email', {
          order_no: this.orderNo,
        })

        this.fetchedFile = res.data
        this.csvFile = null // clear manual upload
      } catch (error) {
        this.errorMessage = error?.response?.data?.details || 'Failed to fetch file'
      } finally {
        this.fetching = false
      }
    },
    removeFetchedFile() {
      this.fetchedFile = null
    },
  },

}
</script>
